import React from 'react';
import { connect } from 'react-redux';

import { TableContainer } from 'apps/auth/components/common/components/TableRow/styles';
import { TableRow } from 'apps/auth/components/common/components/TableRow/TableRow';
import { Separator } from 'apps/auth/components/common/Layout/Separator';
import { formatMoney } from 'apps/auth/helpers/formats';
import { getGaActivityDate } from 'apps/auth/helpers/utils';

const GaDateFeeRateUnit = (props) => {
    const item = props.item;
    const mobileInfo = item.mobileInfo;
    const { textColor, titleColor } = props.options;

    return (
        <>
            <Separator marginBottom="48px" />
            <TableContainer>
                <TableRow title={props.chequeDate} textColor={textColor} titleColor={titleColor}>
                    {getGaActivityDate(item.payTs, props.lang)}
                </TableRow>
                <TableRow title={props.chequeFee} textColor={textColor} titleColor={titleColor}>
                    {formatMoney(mobileInfo.feeUp)} {mobileInfo.frCurIso}
                </TableRow>
                {mobileInfo?.curRate !== 1 && (
                    <TableRow title={props.chequeFxRate} textColor={textColor} titleColor={titleColor}>{`${formatMoney(1)} ${
                        mobileInfo.frCurIso
                    } = ${formatMoney(mobileInfo.curRate, 4)} ${mobileInfo.toCurIso}`}</TableRow>
                )}
                {mobileInfo.extraFields?.promoCode && (
                    <TableRow title={props.chequePromocodeFaild} textColor={textColor} titleColor={titleColor}>
                        {mobileInfo.promoCode}
                    </TableRow>
                )}
            </TableContainer>
        </>
    );
};

const mapStateToProps = (state) => ({
    chequePromocodeFaild: state.messages.pageMessages.chequePromocodeFaild,
    chequeDate: state.messages.pageMessages.chequeDate,
    chequeFee: state.messages.pageMessages.chequeFee,
    chequeFxRate: state.messages.pageMessages.chequeFxRate,
    lang: state.language.lang,
});

export default connect(mapStateToProps)(GaDateFeeRateUnit);
